//-------------------------------------------------------------------------------------------------- Imports
import { Row, Col } from "antd";
import { StyleSheet } from "../../StyleSheet";
import ListComponent, { ListComponentData } from "../../components/ListComponent";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { useCallback, useEffect, useState } from "react";
import { getShowMegan } from "../../methods/Methods";
import { getConfigurableServiceState } from "../../stores/slices/configurableServicesSlice";

//-------------------------------------------------------------------------------------------------- Constants
const ROUTES: Record<string, string> = {
    "Soporte con Megan":    "/technical-support/megan-chat",
    "Preguntas Frecuentes": "/technical-support/frequently-question",
    "Diagnóstico Técnico":  "/technical-support/technical-diagnostics",
    "Lista de Canales de TV": "/technical-support/channel-list",
    "Órdenes de Servicio":  "/technical-support/order-service",
    "Mi Wi-Fi":             "/technical-support/my-network",
};

const item = (title: string): ListComponentData => ({ title, subtitle: "" });

//-------------------------------------------------------------------------------------------------- View
const TechnicalSupport = () => {
    const navigate = useNavigate();
    const generalData = useSelector(getGeneralData);
    const confService = useSelector(getConfigurableServiceState);

    const [idCliente, setIdCliente] = useState("");
    const [showFAQ, setShowFAQ] = useState(false);

    const isEnabled = (name: string) =>
        confService.dataList.some((s) => s.name === name && s.enabled);

    const showMeganChat         = isEnabled("ACTIVATE_AI_SUPPORT_MEGAN");
    const showTechnicalDiagnostics = isEnabled("ACTIVATE_TECHNICAL_DIAGNOSTICS");
    const canUpdateDataNetwork  = confService.dataList.some(
        (s) => s.name.startsWith("DAF_ACTIVATION_MY_NETWORK") && s.enabled
    );

    const getShow = useCallback(async () => {
        await getShowMegan(idCliente)
            .then((response) => setShowFAQ(response.data.data[0].show))
            .catch(() => setShowFAQ(false));
    }, [idCliente]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (idCliente) getShow();
    }, [idCliente, getShow]);

    const optionsArray: ListComponentData[] = [
        ...(showMeganChat || showFAQ ? [item("Preguntas Frecuentes")]   : []),
        ...(showTechnicalDiagnostics ? [item("Diagnóstico Técnico")]    : []),
        item("Lista de Canales de TV"),
        item("Órdenes de Servicio"),
        ...(canUpdateDataNetwork     ? [item("Mi Wi-Fi")]               : []),
    ];

    const goToRoute = (element: ListComponentData) => {
        if (element.title === "Preguntas Frecuentes") {
            navigate(showMeganChat ? ROUTES["Soporte con Megan"] : ROUTES["Preguntas Frecuentes"]);
            return;
        }
        const route = ROUTES[element.title];
        if (route) navigate(route);
    };

    return (
        <SubDefaultLayout title={"Soporte Técnico"}>
            <Row style={styles.rowPrincipal}>
                <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                    <ListComponent
                        arrayList={optionsArray}
                        onPress={(option: ListComponentData) => goToRoute(option)}
                    />
                </Col>
            </Row>
        </SubDefaultLayout>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    rowPrincipal: {
        marginTop: 30,
        display: "flex",
        justifyContent: "center",
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default TechnicalSupport;
